import { makeStyles } from 'tss-react/mui';
import { inputStyles } from 'components/OrderForm/styles';
import { Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const useStyles = makeStyles()(inputStyles);

export const TooltipIcon = ({ title }) => {
  const { classes } = useStyles();

  return (
    <Tooltip title={title}>
      <HelpOutlineIcon className={classes.helpIcon} />
    </Tooltip>
  );
};
